import { GetApp } from "../../App"
import { Block, BlockContainer, BlockFieldInputs, BlockRow } from "../../Components/Block"
import { EditGroup } from "../../Components/EditGroup"
import { Icon, Icons } from "../../Components/Icon"
import { GetShipData } from "./Context"
import { ShipDataRigElementView } from "./RigElementView"
import { ShipDataSailView } from "./SailView"
import { ShipDataSailingViewProps } from "./Params"

export function ShipDataSailingView(_: ShipDataSailingViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { editable, formEditable, edited, onEdited, save, editRigElement, editSail } = GetShipData();
  return (
    <EditGroup changed={edited} editable={formEditable} editableFields={[
      { name: "rigElements", array: true, type: "object", fields: ["id", "rigElement", "manufacturer", "model", { name: "size", type: "int" }, "sizeUnit", "serialNumber", "comment", "placeInstallation"] },

      { name: "sails", array: true, type: "object", fields: ["id", "sail", "sailType", { name: "reefNo", type: "int" }, "manufacturer", { name: "size", type: "int" }, "sizeUnit", "comment"] },
    ]} onSave={save}
    >

      {/* Rig – ShipDataRigView */}
      <BlockContainer>
        <Block>
          <BlockRow>
            <h3>{t("mast_rig")}</h3>
          </BlockRow>

          {editRigElement.items.map((rigElement, index) => (
            <ShipDataRigElementView data={rigElement} editable={editable} index={index} key={rigElement.id} onEdited={onEdited} removeRig={() => { editRigElement.removeAt(index); onEdited(); }} />
          ))}

          <BlockRow>
            <BlockFieldInputs className="button_top_distance">
              <button className="button" disabled={!editable} onClick={() => { editRigElement.add(); onEdited(); }}>
                <Icon icon={Icons.Plus} /> {t("add_rig")}
              </button>
            </BlockFieldInputs>
          </BlockRow>
        </Block>
      </BlockContainer>

      {/* Sails  – ShipDataSailView */}
      <BlockContainer>
        <Block>
          <BlockRow>
            <h3>{t("sails")}</h3>
          </BlockRow>

          {editSail.items.map((sail, index) => (
            <ShipDataSailView data={sail} editable={editable} index={index} key={sail.id} onEdited={onEdited} removeSail={() => { editSail.removeAt(index); onEdited(); }} />
          ))}
          <BlockRow>
            <BlockFieldInputs className="button_top_distance">
              <button className="button" disabled={!editable} onClick={() => { editSail.add(); onEdited(); }}>
                <Icon icon={Icons.Plus} /> {t("add_sail")}
              </button>
            </BlockFieldInputs>
          </BlockRow>
        </Block>
      </BlockContainer>
    </EditGroup>
  );
}
